import { Actions } from '../../../../utils/Action'
import { ActionTypes } from './types'
import { TDefRequest } from '../../../../types/actions'

/// ///////////////////////////////////////////////////////////////////////
const GetFavoritesActivityActions = new Actions('GET_FAVORITES_ACTIVITY', ActionTypes)
const GetFavoritesActivityWith0OffsetActions = new Actions('GET_FAVORITES_ACTIVITY_WITH_O_OFFSET', ActionTypes)

export interface TypeGetFavoritesActivityR extends TDefRequest {
  idTender: number
  offset?: number
  limit?: number
  search?: string
  sortBy?: string
  sort?: string
}

export const GetFavoritesActivity = {
  request: (payload: TypeGetFavoritesActivityR) => GetFavoritesActivityActions.request(payload),
  success: (payload: any) => GetFavoritesActivityActions.success(payload),
  error: (payload: string) => GetFavoritesActivityActions.error(payload),
}
export const GetFavoritesActivityWith0Offset = {
  success: (payload: any) => GetFavoritesActivityWith0OffsetActions.success(payload),
}

/// ///////////////////////////////////////////////////////////////////////
const GetFavoritesActivityChildActions = new Actions('GET_FAVORITES_ACTIVITY_CHILD', ActionTypes)

export interface TypeGetFavoritesActivityChildR extends TDefRequest {
  idItem: number
  idTender: number
}

export const GetFavoritesActivityChild = {
  request: (payload: TypeGetFavoritesActivityChildR) => GetFavoritesActivityChildActions.request(payload),
  success: (payload: any) => GetFavoritesActivityChildActions.success(payload),
  error: (payload: string) => GetFavoritesActivityChildActions.error(payload),
}
